/**
 * @generated SignedSource<<0cec5c90fa71820febe4b51d660c7538>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetWeatherCondition = "BROKEN_CLOUDS" | "CLEAR_SKY" | "FEW_CLOUDS" | "MIST" | "RAIN" | "SCATTERED_CLOUDS" | "SHOWER_RAIN" | "SNOW" | "THUNDERSTORM";
import { FragmentRefs } from "relay-runtime";
export type WidgetWeatherBackground_WidgetWeather$data = {
  readonly currentOccasion: {
    readonly condition: WidgetWeatherCondition;
  } | null;
  readonly " $fragmentType": "WidgetWeatherBackground_WidgetWeather";
};
export type WidgetWeatherBackground_WidgetWeather$key = {
  readonly " $data"?: WidgetWeatherBackground_WidgetWeather$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherBackground_WidgetWeather">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetWeatherBackground_WidgetWeather",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetWeatherOccasion",
      "kind": "LinkedField",
      "name": "currentOccasion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "condition",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetWeather",
  "abstractKey": null
};

(node as any).hash = "091c2d5f27c9ef448abe847488a709a9";

export default node;
